<template>
  <ul class="list">
    <li @click="handle(item.key)" v-for="(item, index) of list" :key="index">{{item.name}}</li>
  </ul>
</template>

<script>
import { setManualLocalePreference } from "@/utils/locale-preference";

export default {
  name: 'ChangeLanguage',
  data() {
    return {
      list: [
        { key: 'zh-TW', name: '\u7E41\u9AD4\u4E2D\u6587' },
        { key: 'en', name: 'English' },
        { key: 'ko', name: '\uD55C\uAD6D\uC5B4' },
      ]
    }
  },
  methods: {
    handle(lang) {
      setManualLocalePreference(lang);
      location.reload()
    }
  }
}
</script>
<style lang="scss" scoped>
  .list{
    padding: 10px 0;
    li{
        line-height: 36px;
        color: #606266;
        padding-left: 20px;
        &:hover{
          background-color: #ecf5ff;
          color: #66b1ff;
        }
    }
  }
</style>
